/* Build style-sheets */
import "../../node_modules/bootstrap/dist/css/bootstrap.css";
// import "./homepage.scss";

import "../ox/um-91/um-91.scss";
import "../ox/um-92/um-92.scss";
import "./4_organisms/_addALine.scss";
import "./4_organisms/_centerSection.scss";
import "./4_organisms/_whyUltraMobile.scss";
import "./4_organisms/_planCardsHomepage2023.scss";
import "./4_organisms/_whatPeopleSay.scss";
import "./4_organisms/_seeIf.scss";
import "./4_organisms/_broadbandLabelHomepage.scss";
import "./4_organisms/plansRefresh23/_broadbad-v1-variation.scss";
import "./4_organisms/_hero2022.scss";
import "./base.js";
// Bootstrap is nededed on the homepage for modals. Currently needed for UM-92
import 'bootstrap';

// legacy v2 code
// Import pre-compiled bootstrap styles
// Import ultra's main scss file. This file imports style-partials that are not associated with a js module.

// import "../../node_modules/bootstrap/js/dist/dropdown";

// import "bootstrap"; // needed for nav dropdown menus

import "../../node_modules/bootstrap/js/dist/dropdown"; // use for dropdown
import "../../node_modules/bootstrap/js/dist/collapse"; // use for dropdown
import { getCookie } from "./11_functions/_cookie";
// import navbar from "./../../src/js/navbar";

// navbar.init();

// end legacy v2 code //

window.dataLayer = window.dataLayer || [];

// videoModal
const lity = () => import(/** webpackChunkName: "lity" */ "./7_vendors/_lity.js");

const planCard2022Tracking = () => import( /* webpackChunkName: "dataTrackingPlanCard2022" */ "./10_dataTracking/_dataTrackingPlanCard2022.js");

const faqDataTracking = () => import(/* webpackChunkName: "FAQ" */ "./10_dataTracking/_faq.js");

const vfAutoOpen = () => import(/* webpackChunkName: "Auto Open" */ "./5_layouts/_vfAutoOpen.js");

const radioGroup = () => import(/* webpackChunkName: "radioGroup" */ "./3_molecules/_radioGroup.js");

const swiperReviewsCarousel = () => import(/* webpackChunkName: "SwiperReviewsCarousel" */ "./6_carousels/_swiperReviewsCarousel.js");

const homeTestimonials2022 = () => import(/* webpackChunkName: "homeTestimonials2022" */ "./6_carousels/_homeTestimonials2022");

const homepageVariation = () => import(/* webpackChunkName: "homepageVariation" */ "./7_vendors/_homepageVariation");

const homepagePlanCards = () => import(/* webpackChunkName: "planCards" */ "./12_pages/_homepagePlanCards");

const dataTrackingVf = () => import(/* webpackChunkName: "dataTrackingVf" */"./10_dataTracking/_dataTrackingVf");

const skipContentLink = () => import(/* webpackChunkName: "skipContentLink" */ './4_organisms/_skipToContent.js');

const lazyLoad = () => import(/* webpackChunkName: "lazyLoad" */"./11_functions/_lazyLoad");

const nav2022 = () => import(/* webpackChunkName: "nav2022" */ "./7_layouts/_nav2022.js");

const dataTrackingFooter2022 = () => import(/* webpackChunkName: "dataTrackingFooter2022" */"./10_dataTracking/_dataTrackingFooter2022");

const broadbandLabel = () => import(/* webpackChunkName: "broadbandLabel" */"./13_webComponents/React/broadBandLabel/fccLabel");

const plansPageCarroussel = () => import(/* webpackChunkName: "plansPageCarroussel"*/ './6_carousels/_plansPageCarrousel');

const yourMustHaveFeaturesForFree = () => import(/* webpackChunkName: "yourMustHaveFeaturesForFree"*/ './13_webComponents/React/yourMustHaveFeaturesForFree');

const helpfulGuides = () => import(/* webpackChunkName: "helpfulGuides"*/ './13_webComponents/React/ox/um-91');

const internationalBenefits = () => import(/* webpackChunkName: "internationalBenefits"*/ './13_webComponents/React/ox/um-92');

const countryModal = () =>
  import(/* webpackChunkName: "countryModal" */ './11_functions/_mobileModal');

  // homepage2022
  yourMustHaveFeaturesForFree();
  lity();
  planCard2022Tracking();
  faqDataTracking();
  vfAutoOpen();
  radioGroup();
  swiperReviewsCarousel();
  homeTestimonials2022();
  homepageVariation();
  homepagePlanCards();
  dataTrackingVf();
  broadbandLabel();
  plansPageCarroussel();
  helpfulGuides();
  internationalBenefits();

  // global scripts
  skipContentLink();
  lazyLoad();
  nav2022();
  dataTrackingFooter2022();


// Modals 
countryModal();
